<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex
        xs12
      >
        <material-card
          title="CTQ Performance文件校驗"
          class="card-shrink card-padding v-card__first"
          color="general"
        >
          <!-- <v-icon
            :class="{'card-shrink-active-icon' : shrink_1}"
            @click="shrink_1=!shrink_1"
          >mdi-apple-keyboard-control</v-icon> -->
          <v-form>
            <v-container
              py-0
              class="mw-100">
              <v-layout wrap>

                 <v-flex
  flex-small
  mt-3
  xs12
  lg1
  text-xs-right
  d-flex
  align-items-center
>
  <!-- 隱藏真正的 input -->
  <input
    ref="fileInput"
    type="file"
    style="display: none"
    @change="uploadTestFile"
  />

  <!-- 自己做按鈕 -->
  <v-btn
    color="black"
    class="white--text"
    small
    @click="triggerFile"
  >
    上傳文件
  </v-btn>
</v-flex>
        <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg4>
                    <!-- 顯示文件名 -->
  <v-text-field
    v-model="fileName"
    label="上傳文件檔名"
    readonly
    dense
    outlined
    class="mr-2"
  />
                   </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <!-- 校驗結果 -->
<v-card
  v-if="validateResult"
  class="mt-4 pa-4"
  outlined
>
  <div class="text-h6 mb-3">
    校驗結果
  </div>

  <div
    class="validation-result"
    v-html="validateResult"
  />
</v-card>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="processingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        PROCESSING 處理中
      </p>
    </v-dialog>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
// import qs from 'qs'
// import Vue from 'vue'
// import VueC3 from 'vue-c3'
// import 'c3/c3.min.css'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'
// import WeekPicker from '@/components/module/datepicker/WeekPicker.vue'

export default {
  name: 'LcdCalibrationAnalyzer',
  //   components: {
  //     WeekPicker
  //   },
  data () {
    return {
      startdate: '2018-04-01',
      highlightedDates: ['2025-02-10', '2025-02-14', '2024-02-20'],
      highlightedEndDates: ['2025-02-08', '2025-02-13', '2024-02-14'],
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      processingView: false,
      validateResult: '',
      // summaryCaseName: '',
      // summaryDate: '',
      // summaryEMS: '',
      // summaryEMSpk: 0,
      // summaryRange: '5',
      // summaryItem: 'CPU_TEMP',
      summaryTableShowList: [],
      // nullDatetime: null,
      // datetime: new Date(),
      // datetimeString: '2019-01-01 12:00',
      // formattedDatetime: '09/01/2019 12:00',
      // textFieldProps: {
      //   appendIcon: 'event'
      // },
      // dateProps: {
      //   headerColor: 'red'
      // },
      // timeProps: {
      //   useSeconds: false,
      //   ampmInTitle: true,
      //   format: '24hr',
      //   allowedMinutes: m => m % 30 === 0
      // },
      showBrightness: true,
      shrink_1: true,
      summaryRangeStartDateMenu: false,
      summaryRangeStartDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      summaryRangeEndDateMenu: false,
      summaryRangeEndDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      summaryFactoryMenu: [],
      summaryFactory: '',
      tempFactory: '',
      summaryProjectMenu: [],
      summaryProject: '',
      tempProject: '',
      summaryprocessMenu: [],
      summaryprocess: '',
      tempprocess: '',
      summarystationMenu: [],
      summarystation: '',
      tempstationMenu: '',
      summaryparameternameMenu: [],
      summaryparametername: '',
      tempparametername: '',
      summaryperiodtypeMenu: [],
      summaryperiodtype: '',
      tempperiodtype: '',
      contentDateList: [],
      summaryDateStart: '',
      fileName: '',
      // biosSn: '',
      // i1Sn: '',
      // mfrid: '',
      // mfrdate: '',
      // errorCode: '',
      // yRangeType: '',
      // yRangeStart: '',
      // yRangeEnd: '',
      // xyCoordinateRangeType: '',
      // xCoordinateRangeStart: '',
      // xCoordinateRangeEnd: '',
      // yCoordinateRangeStart: '',
      // yCoordinateRangeEnd: '',
      // gammaRangeStart: '',
      // gammaRangeEnd: '',
      // gammaDiffRangeStart: '',
      // gammaDiffRangeEnd: '',
      summary: {
        biosSn: '',
        i1Sn: '',
        mfrid: '',
        mfrdate: '',
        errorCode: '',
        yRangeType: '',
        yRangeStart: '',
        yRangeEnd: '',
        xyCoordinateRangeType: '',
        xCoordinateRangeStart: '',
        xCoordinateRangeEnd: '',
        yCoordinateRangeStart: '',
        yCoordinateRangeEnd: '',
        gammaRangeStart: '',
        gammaRangeEnd: '',
        gammaDiffRangeStart: '',
        gammaDiffRangeEnd: ''
      },
      // RangeAll: true,
      // RangeIndex: 999,
      // RangeMin: 0,
      // RangeMax: 9999,
      // RangeMaxList: {
      //   CPU_TEMP: 200,
      //   GPU_TEMP: 200,
      //   CPU_POWER: 200,
      //   GPU_POWER: 200
      // },
      // OverRangeCount: 0,
      // RangeCount: 1,
      passAmount: '0',
      failAmount: '0',
      totalTestInputs: '0',
      submit: false,
      IsSubmitPage: true,
      isSorting: false,
      responseData: [],
      responseDataOnly: [],
      checkTableInputDefine: [
        { text: 'MeasureLoop', value: 'measureLoop' },
        { text: 'Validation0', value: 'validationType0' },
        { text: 'Validation1', value: 'validationType1' },
        { text: 'WriteBIOS', value: 'writeBios' },
        { text: 'PanelIndex', value: 'panelIndex' },
        { text: 'Luminance of White', value: 'luminanceOfWhite' },
        { text: 'Luminance of Black', value: 'luminanceOfBlack' },
        { text: 'Luminance of Red', value: 'luminanceOfRed' },
        { text: 'Luminance of Green', value: 'luminanceOfGreen' },
        { text: 'Luminance of Blue', value: 'luminanceOfBlue' },
        { text: 'CalibrationWY', value: 'calibratedWy' },
        { text: 'CalibratedGamma', value: 'calibratedGamma' },
        { text: 'Gamma', value: 'gamma' },
        { text: 'GammaL', value: 'gammaLow' },
        { text: 'GammaH', value: 'gammaHigh' },
        { text: 'Gamma_Diff', value: 'gammaDiff' },
        { text: 'Contrast', value: 'contrast' },
        { text: 'R/G/B/W', value: 'assignColor' },
        { text: 'x of coordinate', value: 'xcoordinate' },
        { text: 'y of coordinate', value: 'ycoordinate' },
        { text: 'ProjectTargetWx', value: 'projectTargetWx' },
        { text: 'ProjectTargetWy', value: 'projectTargetWy' },
        { text: 'ProjectYLimit', value: 'projectYLimit' },
        { text: 'ImprovedTargetWx', value: 'improvedTargetWx' },
        { text: 'ImprovedTargetWy', value: 'improvedTargetWy' },
        { text: 'PredImprovedTargetWx', value: 'predictImprovedTargetWx' },
        { text: 'PredImprovedTargetWy', value: 'predictImprovedTargetWy' },
        { text: 'MeasImprovedTargetWx', value: 'measureImprovedTargetWx' },
        { text: 'MeasImprovedTargetWy', value: 'measureImprovedTargetWy' },
        { text: 'MeasImprovedTargetWY', value: 'measureImprovedTargetWYY' },
        { text: 'FinalTargetWx', value: 'finalTargetWx' },
        { text: 'FinalTargetWy', value: 'finalTargetWy' },
        { text: 'FinalWx', value: 'finalWx' },
        { text: 'FinalWy', value: 'finalWy' },
        { text: 'FinalWY', value: 'finalWYY' },
        { text: 'CalibratedWhiteDistanceFail', value: 'calibratedWhiteDistanceFail' },
        { text: 'DeltaE_ScoreAvg', value: 'deltaEScoreAvg' },
        { text: 'DeltaE_Score', value: 'deltaEScore' },
        { text: 'CCT', value: 'cct' },
        { text: 'CCT_Gamma', value: 'cctGamma' },
        { text: 'BiosString', value: 'biosString' },
        { text: 'X/Y/Z Info', value: 'xyzInfo' }],
      responseColumnDefine: [
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'Model',
          value: 'Model'
        },
        {
          align: '',
          class: 'table-width-185',
          fixed: true,
          sortable: true,
          text: 'PartNumber',
          value: 'PartNumber'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'Process',
          value: 'Process'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'Station',
          value: 'Station'
        },
        {
          align: '',
          class: 'table-width-200',
          fixed: true,
          sortable: true,
          text: 'ParameterName',
          value: 'ParameterName'
        },
        {
          align: '',
          class: 'table-width-125',
          fixed: true,
          sortable: true,
          text: 'CPK',
          value: 'CPK'
        },
        {
          align: '',
          class: 'table-width-90',
          fixed: true,
          sortable: true,
          text: 'Level',
          value: 'Level'
        },
        {
          align: '',
          class: 'table-width-100',
          fixed: true,
          sortable: true,
          text: 'Max',
          value: 'Max'
        },
        {
          align: '',
          class: 'table-width-110',
          fixed: true,
          sortable: true,
          text: 'Min',
          value: 'Min'
        }
      ],
      responseHeaders: [],
      responseHeadersOnly: [],
      responseHeadersList: [],
      responseColumnClassList: {},
      responseAlignList: {},
      responseTableShowList: {},
      responseTableShowListOnly: {},
      responseAreaData: {
        commonFailQty: 0,
        commonFailRate: 0,
        failQty: 0,
        failRate: 0,
        fanErrorCodeList: [],
        fanFailQty: 0,
        fanFailRate: 0,
        noDefineFailQty: 0,
        passQty: 0,
        passRate: 0,
        productionQty: 0,
        thermalFailQty: 0,
        thermalFailRate: 0,
        warningColor: 'green'
      },
      checkList: [],
      checkTableShowList: [],
      // lineXaxisName: [],
      // lineXaxisValue: [],
      rowsAmount: [10, 25, 50, 100],
      pagination: {
        page: 1,
        current: {
          descending: null,
          page: 1,
          rowsPerPage: 25,
          sortBy: null,
          totalItems: 0
        }
      },
      pages: 1,
      isInitialPageLoad: true
      // handler_bar: new Vue()
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    // pages () {
    //   if(this.responseData.length > 0) {
    //     return this.pagination.rowsPerPage ? Math.ceil(this.responseData.length / this.pagination.rowsPerPage) : 10
    //   }
    // },
    pageslist () {
      let i = 0
      const list = []
      if (this.pagination.current.rowsPerPage) {
        for (i = 0; i < Math.ceil(this.pagination.current.totalItems / this.pagination.current.rowsPerPage); i++) {
          list.push(i + 1)
        }
      }
      return list
    }
    // options_bar () {
    //   return {
    //     data: {
    //       x: 'x',
    //       columns: [
    //         this.barXaxisName,
    //         this.barXaxisValue
    //       ],
    //       labels: true,
    //       // labels: {
    //       //   // format: function (v, id, i, j) { return v + '%' }
    //       // },
    //       // onclick: function (d) { alert(d.index) },
    //       onclick: (d) => { this.summaryList(d.index, 'range') },
    //       type: 'bar',
    //       types: {
    //         'NormalDistribution': 'spline'
    //       },
    //       axes: {
    //         'ModelName': 'y'
    //       }
    //       // colors: {
    //       //   ModelName: '#999999'
    //       // }
    //       // onclick: (d, i) => { this.summaryList(d, i) } // {id: "data23", value: 120, ratio: 0.8, index: 1, name: "data23"}
    //       // color: function (color, d) {
    //       //   // d will be 'id' when called for legends
    //       //   return d.value >= 5.0 ? '#ff0000' : d.value >= 3.0 ? '#ff9800' : color
    //       // }
    //       // color: (color, d) => {
    //       //   // d will be 'id' when called for legends
    //       //   return (this.OverRangeCount > 0 && d.index === this.barXaxisName.length - 2) ? '#ffa500' : color
    //       // }
    //     },
    //     axis: {
    //       x: {
    //         type: 'category', // this needed to load string x value
    //         tick: {
    //           rotate: -45,
    //           multiline: false
    //         }
    //         // label: {
    //         //   text: '期',
    //         //   position: 'outer-center'
    //         // }
    //       },
    //       y: {
    //         // max: this.RangeCount,
    //         // min: 0,
    //         // tick: {
    //         //   // count: this.RangeCount + 1
    //         // },
    //         // padding: {
    //         //   top: 0,
    //         //   bottom: 0
    //         // }
    //         // tick: {
    //         //   format: function (value) { return value + '%' }
    //         // }
    //         // label: {
    //         //   text: '%',
    //         //   position: 'outer-middle'
    //         // }
    //       },
    //       y2: {
    //         // show: true
    //         // label: {
    //         //   text: '億',
    //         //   position: 'outer-middle'
    //         // }
    //       }
    //     },
    //     tooltip: {
    //       format: {
    //         title (d) {
    //           // return `第 ${d} 期`
    //         },
    //         value (value, ratio, id) {
    //           // return `${value} 億`
    //         }
    //       }
    //     },
    //     grid: {
    //       x: {
    //         show: true
    //       },
    //       y: {
    //         show: true
    //       }
    //     },
    //     legend: {
    //       position: 'bottom',
    //       padding: 16,
    //       show: false
    //     },
    //     size: {
    //       // width: 640,
    //       height: 500
    //     }
    //   }
    // }
  },
  watch: {
    summaryFactory (val) {
      this.summaryProjectMenu = [
        { text: 'Test123_UX5406ZA', value: 'Test123_UX5406ZA' },
        { text: 'Test456_X515EA', value: 'Test456_X515EA' }
      ]
      this.summaryprocess = ''
      this.summarystation = ''
      this.summarystation = ''
      this.summaryperiodtype = ''
      if (this.tempProject !== '' && this.isInitialPageLoad) {
        this.summaryProject = this.tempProject
      }
    //   this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/project/${val}`).then(res => res.data)
    //     .then(res => {
    //       if (res.status === 'success') {
    //         this.summaryProjectMenu = res.data
    //         this.summaryCalibrationTypeMenu = []
    //         this.summaryProdIdMenu = []
    //         this.summaryProject = ''
    //         this.summaryCalibrationType = ''
    //         this.summaryProdId = ''
    //         Object.keys(this.summary).forEach(key => {
    //           this.summary[key] = ''
    //         })
    //         if (this.tempProject !== '' && this.isInitialPageLoad) {
    //           this.summaryProject = this.tempProject
    //         }
    //       }
    //     })
    },
    summaryProject (val) {
    //   const body = {
    //     factoryPk: this.summaryFactory,
    //     projectPk: val
    //   }
    //   this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/calibrationType?` + qs.stringify(body)).then(res => res.data)
    //     .then(res => {
    //       if (res.status === 'success') {
    //         this.summaryCalibrationTypeMenu = res.data
    //         this.summaryProdIdMenu = []
    //         this.summaryCalibrationType = ''
    //         this.summaryProdId = ''
    //         Object.keys(this.summary).forEach(key => {
    //           this.summary[key] = ''
    //         })
    //         if (this.tempCalibrationType !== '' && this.isInitialPageLoad) {
    //           this.summaryCalibrationType = this.tempCalibrationType
    //         }
    //       }
    //     })
      this.summaryprocessMenu = [
        { text: 'Forming', value: 'Forming' },
        { text: 'Stamping', value: 'Stamping' },
        { text: 'CNC', value: 'CNC' },
        { text: 'Sandblasting', value: 'Sandblasting' },
        { text: 'Anodizing', value: 'Anodizing' },
        { text: 'MAO', value: 'MAO' },
        { text: 'Assembly', value: 'Assembly' },
        { text: 'Polisning', value: 'Polisning' },
        { text: 'Painting', value: 'Painting' }
      ]
      this.summarystation = ''
      this.summaryparametername = ''
      this.summaryperiodtype = ''
      if (this.tempprocess !== '' && this.isInitialPageLoad) {
        this.summaryprocess = this.tempprocess
      }
    },
    summaryprocess (val) {
    //   const body = {
    //     factoryName: this.summaryFactory,
    //     modelName: this.summaryProject,
    //     OHMType: this.summaryOHMType
    //   }
    //   Object.keys(this.summary).forEach(key => {
    //     this.summary[key] = ''
    //   })
    //   this.$http.get(`/api/tpohm/getSelectOptionData/manufacturingDate?` + qs.stringify(body)).then(res => res.data)
    //     .then(res => {
    //       if (res.code === 0) {
    //         this.highlightedDates = res.data
    //         this.highlightedEndDates = res.data
    //       }
    //     })
      this.summarystationMenu = [
        { text: '印刷工站', value: '印刷工站' },
        { text: '噴精油', value: '噴精油' },
        { text: '上掛', value: '上掛' },
        { text: '陽極槽', value: '陽極槽' },
        { text: '染色槽', value: '染色槽' },
        { text: '下掛', value: '下掛' },
        { text: '封孔槽', value: '封孔槽' },
        { text: 'P尺寸量測', value: 'P尺寸量測' },
        { text: '公模噴砂站', value: '公模噴砂站' }
      ]
      this.summaryparametername = ''
      this.summaryperiodtype = ''
      if (this.tempstation !== '' && this.isInitialPageLoad) {
        this.summarystation = this.tempstation
      }
    },
    summarystation (val) {
    //   const body = {
    //     factoryName: this.summaryFactory,
    //     modelName: this.summaryProject,
    //     OHMType: this.summaryOHMType
    //   }
    //   Object.keys(this.summary).forEach(key => {
    //     this.summary[key] = ''
    //   })
    //   this.$http.get(`/api/tpohm/getSelectOptionData/manufacturingDate?` + qs.stringify(body)).then(res => res.data)
    //     .then(res => {
    //       if (res.code === 0) {
    //         this.highlightedDates = res.data
    //         this.highlightedEndDates = res.data
    //       }
    //     })
      this.summaryparameternameMenu = [
        { text: '功率', value: '功率' },
        { text: '阻抗', value: '阻抗' },
        { text: '溫度', value: '溫度' },
        { text: '功率', value: '功率' },
        { text: '壓力', value: '壓力' },
        { text: '長邊尺寸', value: '長邊尺寸' },
        { text: '寬邊尺寸', value: '寬邊尺寸' },
        { text: '掛具彈力', value: '掛具彈力' },
        { text: 'PH', value: 'PH' }
      ]
      if (this.tempparametername !== '' && this.isInitialPageLoad) {
        this.summaryparametername = this.tempparametername
      }
      if (this.isInitialPageLoad) {
        this.isInitialPageLoad = false
      }
    },
    summaryperiodtype (val) {
      const result = []
      const now = new Date()
      const currentYear = now.getFullYear()
      const endYear = 2023

      // ===== YEAR =====
      if (val === 'year') {
        for (let y = currentYear; y >= endYear; y--) {
          result.push({
            text: `${y}`,
            value: `${y}`
          })
        }
      }

      // ===== MONTH =====
      if (val === 'month') {
        for (let y = currentYear; y >= endYear; y--) {
          for (let m = 12; m >= 1; m--) {
            result.push({
              text: `${y}-${String(m).padStart(2, '0')}`,
              value: `${y}-${String(m).padStart(2, '0')}`
            })
          }
        }
      }

      // ===== SEASON (季度) =====
      if (val === 'season') {
        const seasons = [
          { s: 'Q1', start: '01-01', end: '03-31' },
          { s: 'Q2', start: '04-01', end: '06-30' },
          { s: 'Q3', start: '07-01', end: '09-30' },
          { s: 'Q4', start: '10-01', end: '12-31' }
        ]

        for (let y = currentYear; y >= endYear; y--) {
          for (let i = 3; i >= 0; i--) {
            const item = seasons[i]
            result.push({
              text: `${y} ${item.s} (${item.start} ~ ${item.end})`,
              value: `${y}-${item.s}`
            })
          }
        }
      }

      // ===== WEEK =====
      if (val === 'week') {
        const getWeekRange = (year, week) => {
          const simple = new Date(year, 0, 1 + (week - 1) * 7)
          const dayOfWeek = simple.getDay()
          const ISOweekStart = new Date(simple)

          if (dayOfWeek <= 4) {
            ISOweekStart.setDate(simple.getDate() - dayOfWeek + 1)
          } else {
            ISOweekStart.setDate(simple.getDate() + 8 - dayOfWeek)
          }

          const start = new Date(ISOweekStart)
          const end = new Date(ISOweekStart)
          end.setDate(start.getDate() + 6)

          const format = (d) =>
            `${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

          return {
            start: format(start),
            end: format(end)
          }
        }

        const getWeeksInYear = (year) => {
          const d = new Date(year, 11, 31)
          const week = Math.ceil(
            ((d - new Date(year, 0, 1)) / 86400000 + new Date(year, 0, 1).getDay() + 1) / 7
          )
          return week
        }

        for (let y = currentYear; y >= endYear; y--) {
          const weeks = getWeeksInYear(y)

          for (let w = weeks; w >= 1; w--) {
            const range = getWeekRange(y, w)

            result.push({
              text: `${y} W${w} (${range.start} ~ ${range.end})`,
              value: `${y}-W${w}`
            })
          }
        }
      }

      this.contentDateList = result
    },
    summaryRangeStartDate (val) {
      this.summaryRangeStartDateMenu = false
      // this.startTimeMenu = true
    },
    // startTime (val) {
    //   if (this.startTimeMenuOperating > 0) {
    //     this.startTimeMenuOperating = 0
    //     this.startTimeMenu = false
    //   } else {
    //     this.startTimeMenuOperating = this.startTimeMenuOperating + 1
    //   }
    // },
    // startTimeMenu (val) {
    //   if (!val) {
    //     this.startTimeMenuOperating = 0
    //   }
    // },
    summaryRangeEndDate (val) {
      this.summaryRangeEndDateMenu = false
      // this.endTimeMenu = true
    },
    // endTime (val) {
    //   if (this.endTimeMenuOperating > 0) {
    //     this.endTimeMenuOperating = 0
    //     this.endTimeMenu = false
    //   } else {
    //     this.endTimeMenuOperating = this.endTimeMenuOperating + 1
    //   }
    // },
    // endTimeMenu (val) {
    //   if (!val) {
    //     this.endTimeMenuOperating = 0
    //   }
    // },
    checkTableShowList (val) {
      this.responseHeaders = JSON.parse(JSON.stringify(this.responseHeadersOnly))
      this.responseTableShowList = JSON.parse(JSON.stringify(this.responseTableShowListOnly))

      this.summaryTableShowList.forEach((s, index) => {
        this.checkTableShowList.forEach((c) => {
          this.responseTableShowList[c] = true
          if (s.value === c) {
            this.responseHeaders.push(this.responseHeadersList[index])
          }
        })
      })
    },
    // responseData (val) {
    //   this.pages = Math.ceil(this.totalRows / this.pagination.rowsPerPage)
    //   if (this.pages > 1) {
    //     setTimeout(() => {
    //       this.pagination.page = this.pages
    //     }, 0)
    //     setTimeout(() => {
    //       this.pagination.page = 1
    //     }, 100)
    //   } else {
    //     setTimeout(() => {
    //       this.pagination.rowsPerPage = 1
    //     }, 0)
    //     setTimeout(() => {
    //       this.pagination.rowsPerPage = this.perPageRows
    //     }, 100)
    //   }
    // },
    // perPageRows (val) {
    //   if (val === -1) {
    //     if (confirm('完整顯示將可能導致效能降低，是否仍完整顯示?')) {
    //       this.pagination.rowsPerPage = val
    //       this.pages = Math.ceil(this.responseData.length / this.pagination.rowsPerPage)
    //       this.pagination.page = 1
    //     } else {
    //       setTimeout(() => {
    //         this.perPageRows = this.pagination.rowsPerPage
    //       }, 100)
    //     }
    //   } else {
    //     this.pagination.rowsPerPage = val
    //     this.pages = Math.ceil(this.responseData.length / this.pagination.rowsPerPage)
    //     this.pagination.page = 1
    //   }
    // },
    'pagination.current.sortBy' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isSorting = true
        // 让排序锁在本次事件循环后释放
        this.$nextTick(() => {
          this.isSorting = false
        })
      }
    },
    'pagination.current.descending' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isSorting = true
        this.$nextTick(() => {
          this.isSorting = false
        })
      }
    },
    'pagination.page': {
      handler (newName, oldName) {
        if (this.isSorting) return
        if (this.submit && !this.IsSubmitPage) {
          this.doCTQDataList()
        }
      },
      immediate: true,
      deep: true
    },
    'pagination.current.rowsPerPage': {
      handler (newName, oldName) {
        if (this.isSorting) return
        if (this.submit && !this.IsSubmitPage) {
          this.doCTQDataList()
        }
      },
      immediate: true,
      deep: true
    }
    // 'pagination.page' (val) {
    //   this.checkList = []
    // },
    // 'pagination.rowsPerPage' (val) {
    //   this.checkList = []
    // },
    // 'pagination.sortBy' (val) {
    //   this.checkList = []
    // },
    // 'pagination.descending' (val) {
    //   this.checkList = []
    // }
    // summaryDate (val) {
    //   this.summaryDateMenu = false
    // },
    // summaryItem (val) {
    //   this.doSummary()
    // },
    // summaryRange (val) {
    //   this.doSummary()
    // }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/ctqThermalPerformance/CTQPerformanceFileverfication')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {

        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    openctqplot (pk) {
      const routeData = this.$router.resolve({
        path: '/ctq/CTQAnalyzer/ShowCTQNormaldistributionplot',
        params: { pk }
      })

      window.open(routeData.href, '_blank')
    },
    selectedDate (val) {
      this.summaryDateStart = val
    },
    isPageReload () {
      if (performance.getEntriesByType && performance.getEntriesByType('navigation').length > 0) {
        return performance.getEntriesByType('navigation')[0].type === 'reload'
      } else if (performance.navigation) {
        return performance.navigation.type === 1
      }
      return false
    },
    getEventColor (date) {
      return this.highlightedDates.includes(date) ? 'green' : ''// 蓝色小圆点
    },
    getEndEventColor (date) {
      return this.highlightedEndDates.includes(date) ? 'green' : ''// 蓝色小圆点
    },
    doResponseColumnDefine () {
      // this.responseHeaders.push({
      //   align: '',
      //   class: 'table-width-55',
      //   fixed: true,
      //   sortable: false,
      //   text: '標記',
      //   value: ''
      // })
      // this.responseHeadersOnly.push({
      //   align: '',
      //   class: 'table-width-55',
      //   fixed: true,
      //   sortable: false,
      //   text: '標記',
      //   value: ''
      // })
      console.log('responseColumnDefine:', this.responseColumnDefine)
      console.log('responseTableShowListOnly:', this.responseTableShowListOnly)
      this.responseHeadersList = []
      this.responseHeaders = []
      this.responseHeadersOnly = []
      this.responseTableShowList = {}
      this.responseTableShowListOnly = {}
      this.responseColumnClassList = {}
      this.responseAlignList = {}
      this.summaryTableShowList = []
      this.responseColumnDefine.forEach((r) => {
        if (r.fixed) {
          this.responseHeaders.push(r)
          this.responseHeadersOnly.push(r)
        } else {
          this.responseHeadersList.push(r)
          this.responseTableShowList[r.value] = r.fixed
          this.responseTableShowListOnly[r.value] = r.fixed
          this.responseColumnClassList[r.value] = r.class
          this.responseAlignList[r.value] = r.align
          this.summaryTableShowList.push({ text: r.text, value: r.value })
        }
      })
      console.log('responseHeaders:', this.responseHeaders)
      console.log('responseTableShowList:', this.responseTableShowList)
      console.log('responseTableShowListOnly:', this.responseTableShowListOnly)
    },
    // doBeforeLink (TtrsPk, deviceSn) {
    //   this.$http.post('/api/thermal/getSingleDeviceBurnInDataStatistic?ttrsPk=' + TtrsPk).then(res => res.data)
    //     .then(res => {
    //       if (res.status === 'success') {
    //         let Groups = res.data.fanTestData.length
    //         const routeData = this.$router.resolve({ path: '/thermal/singleDeviceBurnInDataStatistic/' + TtrsPk + '/' + Groups, query: { sn: deviceSn, modelname: this.summaryCaseName, date: this.summaryDate, ems: this.summaryEMS } })
    //         window.open(routeData.href, '_blank')
    //       }
    //     })
    // },
    // doSummary (type) {
    //   this.barXaxisName = ['x']
    //   this.barXaxisValue = ['ModelName']
    //   let AllArray = []
    //   this.responseDataOnly.forEach((r) => {
    //     if (r[this.summaryItem] >= 0) {
    //       AllArray.push(r[this.summaryItem])
    //     }
    //   })
    //   this.RangeMax = Math.ceil(Math.max(...AllArray) / this.summaryRange) * this.summaryRange
    //   this.RangeMin = Math.floor(Math.min(...AllArray) / this.summaryRange) * this.summaryRange
    //   if (this.RangeMax > this.RangeMaxList[this.summaryItem]) {
    //     this.RangeMax = Math.min(this.RangeMax, this.RangeMaxList[this.summaryItem])
    //   }
    //   this.OverRangeCount = 0
    //   const RangeArray = []
    //   for (let i = this.RangeMin; i < this.RangeMax; i = i + this.summaryRange) {
    //     RangeArray[(i - this.RangeMin) / this.summaryRange] = 0
    //   }
    //   AllArray.forEach((r) => {
    //     if (r > this.RangeMaxList[this.summaryItem]) {
    //       this.OverRangeCount = this.OverRangeCount + 1
    //     } else {
    //       if (RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] > 0) {
    //         RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] = RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] + 1
    //       } else {
    //         RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] = 1
    //       }
    //     }
    //   })

    //   this.RangeCount = Math.max(...RangeArray)
    //   for (let i = 0; i < RangeArray.length; i++) {
    //     this.barXaxisValue.push(RangeArray[i] || 0)
    //     switch (true) {
    //       case (this.summaryRange === '5' || this.summaryRange === '10'):
    //         this.barXaxisName.push((this.RangeMin + (i * this.summaryRange)).toFixed(0) + '-' + (this.RangeMin + ((i + 1) * this.summaryRange)).toFixed(0))
    //         break
    //       case (this.summaryRange === '2.5' || this.summaryRange === '7.5'):
    //         this.barXaxisName.push((this.RangeMin + (i * this.summaryRange)).toFixed(1) + '-' + (this.RangeMin + ((i + 1) * this.summaryRange)).toFixed(1))
    //         break
    //       // default:
    //       // return
    //     }
    //   }
    //   if (this.OverRangeCount > 0) {
    //     this.barXaxisValue.push(this.OverRangeCount)
    //     this.barXaxisName.push('>' + this.RangeMaxList[this.summaryItem])
    //   }
    //   // RangeArray.forEach((r, index) => {
    //   //   console.log(r)
    //   //   console.log(index)
    //   //   this.barXaxisValue.push(r)
    //   //   this.barXaxisName.push((this.RangeMin + (index * this.summaryRange)) + '-' + (this.RangeMin + ((index + 1) * this.summaryRange)))
    //   // })
    //   if (type === 'init') {
    //     this.handler_bar.$emit('init', this.options_bar)
    //   } else {
    //     this.handler_bar.$emit('dispatch', chart => {
    //       const options = {
    //         columns: [
    //           this.barXaxisName,
    //           this.barXaxisValue
    //         ]
    //       }
    //       chart.load(options)
    //     })
    //   }
    // },
    checkTableShowListAll () {
      this.checkTableShowList = []
      this.summaryTableShowList.forEach((s) => {
        this.checkTableShowList.push(s.value)
      })
    },
    checkTableShowListClear () {
      this.checkTableShowList = []
    },
    doSubmit () {
      if (this.doSubmitVerification()) {
        this.loadingView = true
        this.pagination.page = 1
        this.pagination.current.rowsPerPage = 25
        this.doCTQDataList()
        this.doCTQSaveFilterInfo()
        // setTimeout(() => {
        //   this.loadingView = false
        // }, 0)
        const Url = '/ctq/CTQAnalyzer/' + this.summaryFactory + '/' + this.summaryProject + '/' + this.summaryprocess + '/' + this.summarystation + '/' + this.summaryparametername + '/' + this.summaryperiodtype
        if (this.$router.history.current.path !== Url) {
          this.$router.replace(Url)
        }
        // Object.keys(this.summary).forEach(key => {
        //   this.summary[key] = ''
        // })
      }
    },
    doSubmitVerification () {
      console.info(this.summaryDateStart)
      if (this.summaryFactory === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Factory'
        return false
      } else if (this.summaryProject === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Project'
        return false
      } else if (this.summaryprocess === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Process'
        return false
      } else if (this.summarystation === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Station'
        return false
      } else if (this.summaryparametername === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Parameter Name'
        return false
      } else if (this.summaryperiodtype === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Period Type'
        return false
      } else if (this.summaryDateStart === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇時間'
        return false
      } else {
        return true
      }
    },
    doCTQSaveFilterInfo () {
      const [partNumber, model] = this.summaryProject.split('_')
      const body = {
        factory: this.summaryFactory,
        factoryName: this.summaryFactoryMenu[this.summaryFactoryMenu.map(e => { return e.value }).indexOf(this.summaryFactory)].text || null,
        partNumber: partNumber,
        project: model,
        process: this.summaryprocess,
        station: this.summarystation,
        parametername: this.summaryparametername,
        periodtype: this.summaryperiodtype,
        searchdate: this.summaryDateStart
        // biosSn: this.biosSn,
        // errorCode: this.errorCode,
        // i1Sn: this.i1Sn,
        // mfrid: this.mfrid,
        // mfrdate: this.mfrdate,
        // yRangeStart: this.yRangeStart,
        // yRangeEnd: this.yRangeEnd,
        // yRangeType: this.yRangeType,
        // gammaRangeStart: this.gammaRangeStart,
        // gammaRangeEnd: this.gammaRangeEnd,
        // gammaDiffRangeStart: this.gammaDiffRangeStart,
        // gammaDiffRangeEnd: this.gammaDiffRangeEnd,
        // xCoordinateRangeStart: this.xCoordinateRangeStart,
        // xCoordinateRangeEnd: this.xCoordinateRangeEnd,
        // yCoordinateRangeStart: this.yCoordinateRangeStart,
        // yCoordinateRangeEnd: this.yCoordinateRangeEnd,
        // xyCoordinateRangeType: this.xyCoordinateRangeType
      }
      localStorage.setItem('ctqFilterInfo', JSON.stringify(body))
      // localStorage.setItem('lcdFilterUpdateTime', this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))
    },
    doCTQDataList () {
      this.submit = true
      const testdata = [
        {
          Model: 'UX5406ZA',
          PartNumber: 'Test123',
          Process: 'Forming',
          Station: '印刷工站',
          ParameterName: '功率',
          CPK: 1.45,
          Level: 'Bad',
          Max: 5.2,
          Min: 4.8,
          pk: 1
        },
        {
          Model: 'UX5406ZA',
          PartNumber: 'Test123',
          Process: 'Stamping',
          Station: '上掛',
          ParameterName: '溫度',
          CPK: 1.32,
          Level: 'Good',
          Max: 2.1,
          Min: 1.7,
          pk: 2
        },
        {
          Model: 'X515EA',
          PartNumber: 'Test456',
          Process: 'CNC',
          Station: '陽極槽',
          ParameterName: '功率',
          CPK: 1.60,
          Level: 'Excellent',
          Max: 10.5,
          Min: 9.8,
          pk: 3
        },
        {
          Model: 'X515EA',
          PartNumber: 'Test456',
          Process: 'Anodizing',
          Station: '封孔槽',
          ParameterName: '長邊尺寸',
          CPK: 1.20,
          Level: 'Ordinary',
          Max: 75,
          Min: 65,
          pk: 4
        },
        {
          Model: 'X515EA',
          PartNumber: 'Test456',
          Process: 'Anodizing',
          Station: '封孔槽',
          ParameterName: '掛具彈力',
          CPK: 1.75,
          Level: 'Good',
          Max: 105,
          Min: 95,
          pk: 5
        }
      ]
      // ✅ 核心逻辑
      let result = []

      if (this.summaryProject === 'Test123_UX5406ZA') {
        result = testdata.filter(item => item.Model === 'UX5406ZA')
      } else {
        result = testdata.filter(item => item.Model !== 'UX5406ZA')
      }
      this.responseData = result
      this.responseDataOnly = result
      this.doResponseColumnDefine()
      this.pagination.current.totalItems = 5
      this.pages = 1
      this.loadingView = false
    },

    downloadCSV () {
      if (this.doSubmitVerification()) {
        this.processingView = true
        const body = {
          factory: this.summaryFactory,
          project: this.summaryProject,
          calibrationType: this.summaryCalibrationType,
          prodId: this.summaryProdId,
          startTime: this.summaryRangeStartDate,
          endTime: this.summaryRangeEndDate,
          ...this.summary
          // biosSn: this.biosSn,
          // errorCode: this.errorCode,
          // i1Sn: this.i1Sn,
          // mfrid: this.mfrid,
          // mfrdate: this.mfrdate,
          // yRangeStart: this.yRangeStart,
          // yRangeEnd: this.yRangeEnd,
          // yRangeType: this.summary.yRangeType,
          // gammaRangeStart: this.gammaRangeStart,
          // gammaRangeEnd: this.gammaRangeEnd,
          // gammaDiffRangeStart: this.gammaDiffRangeStart,
          // gammaDiffRangeEnd: this.gammaDiffRangeEnd,
          // xCoordinateRangeStart: this.xCoordinateRangeStart,
          // xCoordinateRangeEnd: this.xCoordinateRangeEnd,
          // yCoordinateRangeStart: this.yCoordinateRangeStart,
          // yCoordinateRangeEnd: this.yCoordinateRangeEnd,
          // xyCoordinateRangeType: this.xyCoordinateRangeType
        }
        this.$http.post('/api/lcd/analyzeMgmt/lcdCalibrationRawdata.xls', body, { responseType: 'blob' })
          .then(res => {
            this.processingView = false
            if (res.data.type === 'application/json') {
              return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = () => {
                  res.data = JSON.parse(reader.result)
                  if (res.data.status === 'success') {
                    alert(res.data.data)
                    // resolve(Promise.reject(res.data.data))
                  } else {
                    this.snackbar = true
                    this.snackbarColor = 'red'
                    this.snackbarMsg = res.data.errMsg + ' (' + res.data.errCode + ')'
                  }
                }
                reader.onerror = () => {
                  reject(res.data.data)
                }
                reader.readAsText(res.data)
              })
            } else if (res.data.status !== 'failure' && res.headers['content-disposition']) {
              const blob = new Blob([res.data], { type: 'application/octet-stream' })
              const url = window.URL.createObjectURL(blob)
              const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
              const downloadLink = document.createElement('a')
              downloadLink.href = url
              downloadLink.download = fileName

              document.body.appendChild(downloadLink)
              downloadLink.click()
              document.body.removeChild(downloadLink)
            } else {
              this.snackbar = true
              this.snackbarColor = 'red'
              this.snackbarMsg = '下載失敗，請通知系統管理員'
            }
          })
          .catch(err => {
            this.processingView = false
            this.snackbar = true
            this.snackbarColor = 'orange'
            this.snackbarMsg = err
          })
      }
    },
    triggerFile () {
      this.$refs.fileInput.click()
    },
    uploadTestFile (event) {
      this.validateResult = ''
      const file = event.target.files[0]
      if (!file) return

      this.fileName = file.name.toUpperCase()
      console.info(this.fileName)
      const fileNameArr = file.name.split('_')

      if (this.fileName.startsWith('PERFORMANCE') || this.fileName.startsWith('CTQ')) {
        this.factoryname = fileNameArr[2]
      } else {
        this.factoryname = fileNameArr[1]
      }
      console.info(this.factoryname)
      const formData = new FormData()

      formData.append('file', file)
      formData.append('vendorCode', this.factoryname)
      console.info(this.factoryname)
      // formData.append('vendorCode', 'JT-NJ')
      this.$http.post(
        `/api/thermal-module-schedule/validate`,
        formData
      )
        .then(res => {
          console.info(res)
          const result = res.data

          const status = result.status
          const data = result.data

          if (status === 'success') {
            if (data === null || data === '') {
              this.validateResult = '校驗文件成功，文件無異常'
              this.snackbar = true
              this.snackbarColor = 'success'
              this.snackbarMsg = '文件校驗完成'
            } else {
              this.validateResult = data
              this.snackbar = true
              this.snackbarColor = 'red'
              this.snackbarMsg = '文件校驗有異常，請查看校驗結果'
            }
          } else {
            console.error('失败:', result.errMsg)
          }
        })
        .catch(err => {
          console.error('请求异常:', err)
        })
      this.$refs.fileInput.value = ''
    }
  }
}
</script>
<style>
/* .c3-axis-x .tick tspan:hover {
  cursor: pointer;
} */

.text-center {
  text-align: center !important;
}
.validation-result {
  white-space: normal;
  line-height: 1.8;
  font-size: 14px;
  word-break: break-word;
}
</style>
